import styled from 'styled-components';
import { Button } from '@perch-labs/shrike';

export const StyledButton = styled(Button)`
  padding: 8px 16px;
  width: initial !important;
`;
